/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect } from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';

export namespace DraggableDocumentWrapper {
  export interface Props {
    dragProvided: DraggableProvided;
    dragSnapshot: DraggableStateSnapshot;
    setPaused: (isPaused: boolean) => void;
    index: number;
  }
}

export const DraggableDocumentWrapper: React.FC<DraggableDocumentWrapper.Props> = ({
  dragProvided,
  dragSnapshot,
  setPaused,
  index,
  children,
}) => {
  useEffect(() => {
    dragSnapshot.isDragging ? setPaused(true) : setPaused(false);
  }, [dragSnapshot.isDragging, setPaused]);

  return (
    <div
      ref={dragProvided.innerRef}
      {...dragProvided.draggableProps}
      {...dragProvided.dragHandleProps}
      data-it={`document-row-${index}`}
    >
      {children}
    </div>
  );
};
